import en_US from '../../date-picker/locale/en_US';
export default en_US;
//# sourceMappingURL=en_US.js.map



//////////////////
// WEBPACK FOOTER
// ./~/antd/es/calendar/locale/en_US.js
// module id = 316
// module chunks = 3